export default {
    // ----------Title----------
    proformaSales: 'Proforma Sales',
    salesCreditNote: 'Sales Credit Note',
    replacementDelivery: 'Replacement Delivery',
    retailCashSale: 'Retail Cash Sale',
    purchaseOrder: 'Purchase Order',
    purchaseReturn: 'Purchase Return',
    purchaseInvoice: 'Purchase Invoice',
    deliveryTrips: 'Delivery Trips',
    pickOrders: 'Pick Orders',
    itemReceive: 'Item Receive',
    itemTransfer: 'Item Transfer',
    itemRelocate: 'Item Relocate',
    itemIssue: 'Item Issue',
    itemAdjustment: 'Item Adjustment',
    itemTransform: 'Item Transform',
    stockTake: 'Stock Take',
    executeStockTake: 'Execute Stock Take',
    transferReturn: 'Transfer Return',
    transferRequisition: 'Transfer Requisition',
    retailPrescription: 'Retail Prescription',
    document: 'Document',
    generateFromDeliveryOrders: 'Generate From Delivery Orders',
    scopeTheRangeOfTheCustomerProfiles: 'Scope the range of the customer profiles',
    dateRange: 'Date Range',
    documentDateforDeliveryOrders: 'Document Date for Delivery Orders',
    generateFromContainer: 'Generate From Container',
    basicInformationAboutTheDocument: 'Basic information about the document',

    cashCollection: 'Cash Collection',
    optionalForCollectionUponDelivery: 'Optional for collection upon delivery',
    hubDistribution: 'Hub Distribution',
    deliveryDistributionLocations: 'Delivery distribution locations',
    relatedProfilesAttachedToDocument: 'Related Profiles Attached To Document',
    relatedWarehouseLocationToProcess: 'Related Warehouse Location to Process',
    relatedProfilesToProcess: 'Related Profiles to Process',
    relatedDocs: 'Related Docs',
    relatedDocument: 'Related Documents',
    relatedDocumentAttached: 'Related document attached',

    approvalStatus: 'Approval Status',
    relatedProfileInfoAttachedToDocument: 'Related profile info attached to document',
    documentNo: 'Document No.',
    trackingNo: 'Tracking No',
    collection: 'Collection',
    distributeVia: 'Distribute Via',
    placeBy: 'Placed By',
    delivery: 'Delivery',
    detailInformationAboutTheItemsInvolved: 'Detail information about the items involved',
    generateSingleInvoice: 'Generate Single Invoice',
    fromContainer: 'From Container',
    detailInformationAboutTheDocumentsInvolved: 'Detail information about the documents involved',
    detailInformationAboutTheDocumentItemsInvolved: 'Detail information about the document items involved',
    loadFromDocuments: 'Load From Documents',

    payment: 'Payment',
    relatedPaymentAttachedToDocument: 'Related payment attached to document',
    chooseTypes: 'Choose Types',
    paymentMethod: 'Payment Method',
    paymentType: 'Payment Type',
    payerName: 'Payer Name',
    receivedAmount: 'Received Amount',
    orderAmount: 'Order Amount',
    suppliedBy: 'Supplied By',
    logistic: 'Logistic',
    driver: 'Driver',

    memberProfile: 'Member Profile',
    privateNote: 'Private Note',
    itemInformation: 'Item Information',
    savedVerifedOut: 'Saved Verifed Out',
    savedData: 'Saved Data',
    usage: 'Usage',
    youHaveNotSelectAnyInventoryYet: 'You have not select any inventory yet.',

    relocateFromNormalRacks: 'Relocate from Normal Racks',
    relocateFromReservedRacks: 'Relocate from Reserved Racks',
    transformToDefaultUom: 'Transform To Default Uom',

    // -----------Drawer---------
    noPreviewInformation: 'No Preview Information',
    previewCharges: 'Preview Charges',
    no: 'No.',
    item: 'Item',
    particulars: 'Particulars',
    itemRate: 'Item Rate',
    chargeAmount: 'Charge Amount',
    shippingRates: 'Shipping Rates',
    totalSelected: 'Total Selected',
    documents: 'Documents',
    generateInvoiceNow: 'Generate Invoice Now',
    savedValidation: 'Saved Validation',
    newValidation: 'New Validation',
    addNewValidation: 'Add New Validation',
    viewSavedValidation: 'View Saved Validation',
    validationSaved: 'Validation Saved',
    inventory: 'Inventory',
    slot: 'Slot',
    rack: 'Rack',
    availableQty: 'Available Qty',
    batchNo: 'Batch No.',
    expiryDate: 'Expiry Date',
    storage: 'Storage',
    selectAvailableInventory: 'Select Available Inventory',
    metricType: 'Metric Type',

    // -----------MUI-----------
    loadFrom: 'Load From...',
    relocateThreshold: 'Relocate Threshold',
    defaultUom: 'Default Uom',
    docNo: 'Doc No.',
    docNumber: 'Doc Number',
    docDate: 'Doc Date',
    invoiceNo: 'Invoice No.',
    billingName: 'Billing Name',
    billingAddress: 'Billing Address',
    date: 'Date',
    validation: 'Validation',
    generateFromDO: 'Generate From DO',
    documentDateFrom: 'Document Date From',
    documentDateTo: 'Document Date To',
    code: 'Code',
    qty: 'Qty',
    startQuery: 'Start Query',
    billTo: 'Bill to',
    shipTo: 'Ship To',
    subTotal: 'Sub Total',
    total: 'Total',
    tax: 'Tax',
    roundOffAmount: 'Round off Amount',
    appliedTax: 'Applied Taxes',
    discount: 'Discount',
    taxAmount: 'Tax Amount',
    totalAmount: 'Total Amount',
    requiredAmount: 'Required Amount',
    collectedAmount: 'Collected Amount',
    distributionLocation: 'Distribution Location',
    generateInvoices: 'Generate Invoices',
    marking: 'Marking',
    validated: 'Validated',
    pending: 'Pending',
    balance: 'Balance',
    uom: 'Uom',
    itemName: 'Name',
    editDocument: 'Edit Document',
    printPreview: 'Print Preview',
    dimension: 'Dimension (WxHxL)',
    addItem: 'Add Item',
    customer: 'Customer',
    required: 'Required',
    completed: 'Completed',
    amount: 'Amount',
    cost: 'Cost',
    lastValidated: 'Last Validated',
    validateIn: 'Validate In',
    validateOut: 'Validate Out',
    fromLocation: 'From Location',
    locationTo: 'Location To',
    strictMode: 'Strict Mode',
    execute: 'Execute',

    deductQty: 'Deduct Qty',
    verifiedAt: 'Verified At',
    verifiedBy: 'Verified By',
    savedQty: 'Saved Qty',
    action: 'Action',
    batchNumber: 'Batch Number',
    totalQty: 'Total Qty',
    confirmedAt: 'Confirmed at',
    markAsConfirm: 'Mark as Confirm',
    recipient: 'Recipient',
    regions: 'Regions',
    completion: 'Completion',
    yesIveConfirmed: "Yes, I've Confirmed",
    from: 'From',
    to: 'To',
    normal: 'Normal',
    reserved: 'Reserved',
    storageFrom: 'Storage From',
    toStorage: 'To Storage',
    increase: 'Increase',
    decrease: 'Decrease',
    itemCode: 'Item Code',
    selectedItems: 'Selected Items',
    transformTo: 'Transform To',
    availableInventory: 'Available Inventory',

    currentPreview: 'Current Preview',
    suggestion: 'Suggestion',
    noAction: 'No action',
    actions: 'Actions',
    adjustment: 'Adjustment',
    issue: 'Issue',
    selectedInventoryQty: 'Selected Inventory Qty',
    customFinalQty: 'Custom Final Qty',
    finalQty: 'Final Qty',
    transformInto: 'Transform Into',
    allocation: 'Allocation',
    newBatchNo: 'New Batch No',
    modifySelection: 'Modify Selection',
    consumption: 'Consumption',
    selectInventory: 'Select Inventory',

    receiveQty: 'Receive Qty',
    remainQty: 'Remain Qty',
    brand: 'Brand',
    stockValue: 'Stock Value',

    trackBatchReceives: 'Track Batch Receives',
    stockPosted: 'Stock Posted',
    posted: 'Posted',
    orderedBy: 'Ordered By',
    requiredQty: 'Required Qty',

    reference: 'Reference',
    receivableAmount: 'Receivable Amount',
    change: 'Change',

    importDataSets: 'Import Data Sets',
    downloadFormat: 'Download Format',
    importedRows: 'Imported Rows',
    totalStockTakeQty: 'Total Stock Take Qty',
    itemId: 'Item Id',
    stockTakeQty: 'Stock Take Qty',
    uomName: 'Uom Name',
    uomId: 'Uom Id',

    searchPickDocuments: 'Search Pick Documents',

    defaultLocationNotFound: 'Default location not found',
}